import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// SectionHead , centered H1 used at the top of every form section.
// SectionCaption , small uppercase caption used to group list rows.
// Hint , 12px muted text used under form fields and toggles.
// Label , uppercase 11px / 700 form-field label.
//
//   <SectionHead title="Allgemein" />
//   <SectionCaption>Aktive Abstimmungen (12)</SectionCaption>
//   <Label htmlFor="…">Frage</Label>
//   <Hint>Wenn aktiviert, …</Hint>
// ─────────────────────────────────────────────────────────────────────────────

export function SectionHead({ title, children, align = 'center', className = '' }) {
  return (
    <div
      className={
        'mb-7 ' +
        (align === 'center' ? 'text-center ' : 'text-left ') +
        (className || '')
      }
    >
      {children}
      <h1 className="m-0 text-[34px] font-semibold tracking-[-0.028em] leading-[1.08] text-[#1a1816]">
        {title}
      </h1>
    </div>
  )
}

export function SectionCaption({ children, className = '' }) {
  return (
    <h3
      className={
        'm-0 text-[11.5px] font-bold uppercase tracking-[0.06em] text-[#6b6862] ' +
        (className || '')
      }
    >
      {children}
    </h3>
  )
}

export function Label({ htmlFor, className = '', children }) {
  return (
    <label
      htmlFor={htmlFor}
      className={
        'block text-[11px] font-bold uppercase tracking-[0.06em] text-[#6b6862] mb-1.5 ' +
        (className || '')
      }
    >
      {children}
    </label>
  )
}

export function Hint({ className = '', children }) {
  return (
    <span
      className={
        'block text-[12px] text-[#6b6862] leading-relaxed ' +
        (className || '')
      }
    >
      {children}
    </span>
  )
}

// Kicker , 10.5px uppercase orange caption used above big titles.
export function Kicker({ className = '', children }) {
  return (
    <span
      className={
        'block text-[10.5px] font-bold uppercase tracking-[0.10em] text-[#e85d1f] ' +
        (className || '')
      }
    >
      {children}
    </span>
  )
}
